export interface IServicingMsrLoan {
  id: number
  loanId: string
  upbServiced: number
  capitalizedMsr: number
  accumAmort: number
  carryingValue: number
}

export interface IServicingSettings {
  id: number
  msrGlAccountNo: string
  servicingFeeIncome: number
  servicingFeeGlAccountNo: string
  msrAmortization: number
  msrAmortizationGlAccountNo: string
}

export interface IServicingPeriodItem {
  key: string
  label: string
  amount: number
  glAccountNo: string
  glBalance: number
  ok: boolean
}

export const emptyServicingMsrLoan = (): Partial<IServicingMsrLoan> => ({
  loanId: '',
  upbServiced: 0,
  capitalizedMsr: 0,
  accumAmort: 0,
})
